<template>
    <!-- Edit-page page-bar: name + version on the left; the page's own actions (slot), Cancel and Save on the right -->
    <div class="page-bar ep-bar" ref="bar">
        <div class="pb-detail">
            <div class="page-bar-sub">
                <a class="pb-crumb" @click.prevent="$emit('cancel')">
                    <svg viewBox="0 0 24 24"><path d="M19 12H5M11 18l-6-6 6-6" /></svg>Back to {{ typeLabel }}
                </a>
            </div>
            <div class="pb-title">
                <!-- Like the live page, the name shows here rather than in the document; it's edited in Details -->
                <span class="page-bar-main">{{ name || 'Untitled ' + typeLabel }}</span>
                <span class="dbadge st-draft">Editing v{{ version }}</span>
                <span v-if="dirty" class="ep-unsaved"><i></i>Unsaved changes</span>
            </div>
        </div>
        <div class="pb-actions ep-actions">
            <slot />
            <span v-if="$slots.default" class="ep-vsep"></span>
            <button type="button" class="btn-light pb-btn" @click="$emit('cancel')">Cancel</button>
            <!-- Not disabled when nothing changed: saving is also how a draft gets published -->
            <button type="button" class="btn pb-btn" @click="$emit('save')">
                <svg viewBox="0 0 24 24"><path d="M5 3h11l5 5v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2zM7 3v5h8V3M7 21v-7h10v7" /></svg><span>Save</span>
            </button>
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
    name: 'EditorBar',
    // typeLabel: lower-case node type for "Back to …" / "Untitled …", e.g. 'process', 'value engine'
    props: [ 'name', 'version', 'dirty', 'typeLabel' ],
    // height: the bar's height, so the page's sticky rows can sit just under it
    emits: [ 'cancel', 'save', 'height' ],
    data() {
        return {
            observer: null as any
        }
    },
    mounted() {
        const bar = this.$refs.bar as HTMLElement;
        const update = () => { this.$emit('height', bar.offsetHeight); };
        update();
        if((window as any).ResizeObserver) {
            this.observer = new ResizeObserver(update);
            this.observer.observe(bar);
        }
    },
    beforeUnmount() {
        if(this.observer) this.observer.disconnect();
    }
});
</script>
